import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  Tooltip,
  CircularProgress,
  DialogTitle,
  Stack,
  Slide,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from "../../../assets/images/nopdf.png";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TransitionProps } from "@mui/material/transitions";
import { useTheme, useMediaQuery } from "@mui/material";
const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: '95vw', sm: '90vw', md: '80vw', lg: '70vw' }, // Responsive width
  maxWidth: '1100px', // Slightly adjusted max width
  height: { xs: '80vh', md: '85vh' },          // Responsive height
  bgcolor: "background.paper", // Use theme background
  border: 'none', // Remove border, rely on shadow
  borderRadius: '12px', // More rounded corners for modal
  boxShadow: 24,
  p: 0, // Remove padding here, apply to inner boxes
  display: 'flex',
  flexDirection: 'column', // Stack title/close button and iframe
  overflow: 'hidden', // Prevent content spill
};


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});




type Props = {};

const SplitPage = (props: Props) => {

  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState<any>({});
  const [pdfData, setPdfData] = useState<any>(null);
  const [btnLoad, setBtnLoad] = useState(false);
  const [btnLoad1, setBtnLoad1] = useState(false);
  const [btnLoad2, setBtnLoad2] = useState(false);
  const [active, setActive] = useState(true);
  const [isLoadingTableData, setIsLoadingTableData] = useState(true);
  console.log("selectedPdf", selectedPdf)
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  // const handleViewPDF = (row: any) => {
  //   setSelectedPdf(row);
  //   const formattedPdf = row.pdfBase64.startsWith('data:application/pdf;base64,')
  //     ? row.pdfBase64
  //     : `data:application/pdf;base64,${row.pdfBase64}`;

  //   const byteCharacters = atob(formattedPdf.split(',')[1]);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: 'application/pdf' });
  //   const blobUrl = URL.createObjectURL(blob);
  //   setPdfData(blobUrl);

  //   setOpenPdfModal(true);
  // };
  const handleViewPDF = (row: any) => {
    setSelectedPdf(row);
    setPdfData(row.pdfPath); // direct PDF URL assign karo
    setOpenPdfModal(true);
  };

  const handleCloseModal = () => {
    setOpenPdfModal(false);
    setSelectedPdf(null);
    setPdfData(null);
  };
  const location = useLocation();

  const ConvertBase64 = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const otherDocChangeHandler = async (event: any, params: any) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      formik.setFieldValue("fileName", file.name);
      const fileNameParts = file.name.split(".");
      const fileExtension = fileNameParts[fileNameParts.length - 1];
      if (fileExtension.toLowerCase() === "pdf") {
        const base64 = await ConvertBase64(file);
        formik.setFieldValue(params, base64);
        console.log(base64);
      } else {
        alert("Only PDF files are allowed to be uploaded.");
        event.target.value = null;
      }
    }
  };

  let navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const [toaster, setToaster] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [DocFileOption, setDocFileOption] = useState([
    { value: "-1", label: t("text.SelectFileType") },
  ]);
  const [isRowSelected, setIsRowSelected] = useState(false);
    const [isFileSaved, setIsFileSaved] = useState(false);
  const [isMergedIndex, setIsMergedIndex] = useState(false);
  useEffect(() => {


    getDocMng();

  }, []);

  const [searchTerm, setSearchTerm] = useState('');

  // Filter table data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm) return tableData;

    return tableData.filter((row: any) => {
      return (
        row.pgNF?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.pgNU?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.phyIndex?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.comments?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.fileName?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  }, [tableData, searchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };



  const getDocMng = () => {
    const collectData = {
      dPgid: -1,
      pdFid:
        location.state &&
          location.state.pdFid !== undefined &&
          location.state.pdFid !== null
          ? location.state.pdFid
          : location.state.pfid,
      chiPDFid: -1,
      user_Id: -1,
      userId: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocFPages/GetDocFPages`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            id: res.data.data[index]["dPgid"],
            pgNF: res.data.data[index]["pgNF"],
            pgNU: res.data.data[index]["pgNU"],
            phyIndex: res.data.data[index]["phyIndex"],
            comments: res.data.data[index]["comments"],
            phySNo: res.data.data[index]["phySNo"],
            relOfficer: res.data.data[index]["relOfficer"],
            pdFid: res.data.data[index]["pdFid"],
            fileName: res.data.data[index]["fileName"],
            pdfPath: res.data.data[index]["pdfPath"],
            pdfBase64: res.data.data[index]["pdfBase64"],
            isSelected: false,
          });
        }
        setTableData(arr);
        setIsLoadingTableData(false);
      });
  };

  //   const getFileType = () => {
  //     const collectData = {
  //       docID: -1,
  //     };
  //     axios
  //       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
  //       .then((res) => {
  //         const arr = res?.data?.data?.map((item: any) => ({
  //           label: item?.doc_Name,
  //           value: item?.docID,
  //         }));
  //         setDocFileOption(arr);
  //       });
  //   };

  const handleInputChange = (id: number, columnName: string, value: any) => {
    setTableData((prevTableData: any) =>
      prevTableData.map((row: any) =>
        row.id === id ? { ...row, [columnName]: value.label || value } : row
      )
    );
  };
  const formik = useFormik({
    initialValues: {
      divisionid: "",
      txtFPath: "",
      docMid: "",
      fileName: "",
      fileNO: "-1",
      othercomment: "",
      flid: 0,
      user_Id: 0,
      docBase64: "",
      txtmain: "",
      pdfPath: "",
      pdfto: ""
    },

    onSubmit: async (values) => {

      values.docMid = "";
      console.log("Before submission formik values", values);
      setBtnLoad2(true);

      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `DocMangr/AddPDFMergeflpupload`,
          values
        );
        if (response.data.isSuccess) {
          setIsFileSaved(true);
          console.error("response.data.data:", response.data.data);
          formik.setFieldValue("txtFPath", String(response.data.data))
          setBtnLoad2(false);

          toast.success(response.data.mesg);
          //navigate('/DocManagement/DocMng');
        } else {
          toast.error(response.data.mesg);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occurred. Please try again.");
      }
    },
  });

  const back = useNavigate();

  const [pdfid, setPdfid] = useState<any>("");
  const [pdfPath, setPDFPath] = useState("");

  const hasValidData = tableData.some(
    (row: any) =>
      row.pgNF !== 0 ||
      row.pgNU !== 0 ||
      (row.comments && row.comments.trim() !== "")
  );
  const getFilePath = (id: any) => {
    const collectData = {
      pdFid: id,
      user_id: 0,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `DocFiles/GetDocFiles`, collectData)
      .then((response) => {
        const fileData = response.data.data[0];
        console.log("check", fileData);

        // 👇 Use pdfBase64 instead of pdfPath
        formik.setFieldValue("txtmain", fileData.pdfBase64);

        // Keep divisionid assignment
        formik.setFieldValue("divisionid", String(fileData.divisionid));
      });
  };

  // const getFilePath = (id: any) => {
  //   const collectData = {
  //     pdFid: id,
  //     user_id: 0,
  //   };
  //   console.log("collectData " + JSON.stringify(collectData));
  //   axios
  //     .post(HOST_URL.HOST_URL2 + `DocFiles/GetDocFiles`, collectData)
  //     .then((response) => {
  //       console.log("check", response.data.data[0]["pdfPath"]);
  //       formik.setFieldValue("txtmain", response.data.data[0]["pdfPath"]);
  //       formik.setFieldValue("divisionid", String(response.data.data[0]["divisionid"]))
  //     });
  // };
  const dataUpdate = (row: any) => {
    console.log("check row", row);
    setPdfid(row.id);
    formik.setFieldValue("flid", row.id);
    formik.setFieldValue("pdfPath", row.pdfBase64);
    formik.setFieldValue("pdfto", row.pgNU);
    setIsFileSaved(false);
    setIsMergedIndex(false);
    getFilePath(row.pdFid);
  };

  const PDFMerge = () => {
    setBtnLoad(true)
    const collectData = {
      flid: formik.values.flid,
      mergepdf: formik.values.pdfPath,
      txtPdfPath: formik.values.txtFPath,
      // mfl: "",
      mfl: "",
      txtOutPutPath: "",
      // txtOutPutPath: formik.values.pdfPath,
      txtPdfNm: formik.values.fileName,
      othercomment: formik.values.othercomment,
      // chiPDFid: -1,
      // user_Id: -1,
      // userId: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/AddPDFMerge`, collectData)
      .then((res) => {
        const arr: any = [];
        if (res.data.isSuccess == true) {
          setIsMergedIndex(true);
          toast.success(res.data.mesg);
          setBtnLoad(false);

          setTimeout(() => {
            setActive(false);

          }, 1000);
        } else {
          toast.error(res.data.mesg)
        }
      });
  };
  const MainSplitMerge = () => {
    setBtnLoad1(true);
    const collectData = {
      txtmain: formik.values.txtmain,
      filnm: formik.values.fileName,
      pdfto: formik.values.pdfto + "",
      locationid: formik.values.txtFPath,
      txtPdfPath: formik.values.txtFPath
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/MianSplitFileMerge`, collectData)
      .then((res) => {
        console.log(res.data.isSuccess);
        console.log("successMsg", res.data.mesg)

        if (res.data.isSuccess == true) {
          setToaster(true)

          toast.success(res.data.mesg)
          setBtnLoad1(false);

          // setTimeout(() => {
          //   navigate('/DocManagement/DocumentIndexing');
          // }, 1000);
          setTimeout(() => {
            navigate('/DocManagement/DocumentIndexing');
            setTimeout(() => {
              window.location.reload();
            }, 500); // 500ms बाद reload
          }, 1000);

        } else {
          setToaster(true)
          toast.error(res.data.mesg)
        }
      });
  };
  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          // border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.SplitPage")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />

          <form onSubmit={formik.handleSubmit}>
            <ToastApp />
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12} spacing={2}>
                {/* Search TextField */}
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  sx={{ mb: 2 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchTerm && (
                          <IconButton onClick={clearSearch} size="small">
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            <Grid item xs={12}>
  <Box sx={{ width: "100%", overflowX: "auto" }}>
    <Table
      style={{
        borderCollapse: "collapse",
        minWidth: "700px",   // 🔥 important
        border: "1px solid black"
      }}
    >
                  <thead
                    style={{
                      backgroundColor: "#2196f3",
                      color: "#f5f5f5",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingBlock: "10",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.SrNo")}
                      </th>

                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.PageFrom")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.PageTo")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.PhysicalIndex")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.Comments")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.ViewFile")}
                      </th>
                      {/* <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                              {"Search Keywords"}
                            </th> */}
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.AddPdf")}
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "1px solid black", position: "relative" }}>
                    {isLoadingTableData ? (
                      <tr>
                        <td colSpan={7} style={{ height: "200px", textAlign: "center" }}>
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            height="100%"
                          >
                            <CircularProgress />
                            <Typography sx={{ mt: 2 }}>{t("text.LoadingData")}...</Typography>
                          </Box>
                        </td>
                      </tr>
                    ) : filteredData.length > 0 ? (
                      filteredData.map((row: any, index: any) => (
                        <tr key={row.id} style={{ border: "1px solid black" }}>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            {index + 1}
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            {row.pgNF}
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            {row.pgNU}
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            {row.phyIndex}
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            {row.comments}
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          <p
  onClick={() => {
    if (isMobile) {
      // 📱 MOBILE → direct open
      if (row.pdfPath) {
        window.open(row.pdfPath, "_blank", "noopener,noreferrer");
      } else {
        toast.error("PDF not found");
      }
    } else {
      // 💻 DESKTOP → modal open
      handleViewPDF(row);
    }
  }}
  style={{
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
    margin: 0
  }}
>
  {row.fileName}
</p>
                          </td>
                          <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                            <p
                              onClick={() => dataUpdate(row)}
                              style={{ cursor: "pointer", color: "blue", textDecoration: "underline", margin: 0 }}
                            >
                              {t("text.add")}
                            </p>
                          </td>
                        </tr>

                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                          <Typography color="textSecondary">{t("text.NoDataAvailable")}</Typography>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                    </Box>
              </Grid>
            </Grid>
            <br />
            <Divider />

            <br />

            <Grid item xs={12} container spacing={2}>
              <Grid item md={4} xs={12}>
                <TextField
                  type="file"
                  inputProps={{ accept: "application/pdf" }}
                  InputLabelProps={{ shrink: true }}
                  label={
                    <strong style={{ color: "#000" }}>
                      {t("text.EnterDocUpload")}
                    </strong>
                  }
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={(e) => otherDocChangeHandler(e, "docBase64")}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  type="text"
                  // InputLabelProps={{ shrink: true }}
                  id="othercomment"
                  name="othercomment"
                  label={t("text.EnterRemark")}
                  value={formik.values.othercomment}
                  placeholder={t("text.EnterRemark")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  type="text"
                  // InputLabelProps={{ shrink: true }}
                  label={t("text.EnterValue")}
                  value={pdfid}
                  placeholder={t("text.EnterValue")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  // onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item md={2} xs={6}>
                <Button
                  onClick={() => formik.handleSubmit()}
                  type="submit"
                  disabled={!hasValidData || btnLoad2}
                  fullWidth
                  style={{
                    backgroundColor: "#3D39B5",
                    color: "white",
                  }}
                >
                  {btnLoad2 ? <CircularProgress size={24} color="inherit" /> : t("text.FileSaved")}
                </Button>
              </Grid>
            </Grid>

            <br />
            <Divider />

            <br />
            <Grid item xs={12} container spacing={2}>
              <Grid item md={3} xs={12}>
                <TextField
                  type="text"
                  // InputLabelProps={{ shrink: true }}
                  id="txtmain"
                  name="txtmain"
                  label={t("text.EnterMainPdf")}
                  value={formik.values.txtmain}
                  placeholder={t("text.EnterMainPdf")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  // onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  type="text"
                  InputLabelProps={{ shrink: true }}
                  id="txtFPath"
                  name="txtFPath"
                  label={t("text.EnterPdf")}
                  value={formik.values.txtFPath}
                  placeholder={t("text.EnterPdf")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item md={3} xs={6}>
               <Button
  onClick={PDFMerge}
  disabled={!isFileSaved || btnLoad}
  sx={{
    backgroundColor: "#3D39B5",
    color: "white",
    "&.Mui-disabled": {
      backgroundColor: "#b0b0b0",
      color: "#666",
    },
      "&:hover": {
                    backgroundColor: "#3D39B5",
                    color: "white",
                  },
  }}
>
                  {btnLoad ? <CircularProgress size={24} color="inherit" /> : t("text.MergeToIndexFile")}
                </Button>
              </Grid>
              <Grid item md={3} xs={6}>
              <Button
                onClick={MainSplitMerge}
                disabled={!isMergedIndex || btnLoad1}
                sx={{
                  backgroundColor: "#3D39B5",
                  color: "white",
                  "&.Mui-disabled": {
                    backgroundColor: "#b0b0b0",
                    color: "#666",
                  },
                  "&:hover": {
                    backgroundColor: "#3D39B5",
                    color: "white",
                  },
                }}
              >
                {btnLoad1 ? <CircularProgress size={24} color="inherit" /> : t("text.MergeToOriginalFile")}
              </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>



      <Dialog
        open={openPdfModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        maxWidth="xl" // Use XL for PDFs
        fullWidth
        aria-labelledby="pdf-dialog-title"
        PaperProps={{ sx: { height: '90vh' } }} // Control dialog paper height
      >
        <DialogTitle sx={{ py: 1.5, borderBottom: theme => `1px solid ${theme.palette.divider}` }}> {/* Adjust padding & add border */}
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            {/* Truncate title if too long */}
            <Typography variant="h6" component="div" noWrap sx={{ maxWidth: 'calc(100% - 50px)' }}>
              {selectedPdf?.fileName || 'View PDF'}
            </Typography>
            <IconButton aria-label="close" onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ p: 0, overflow: 'hidden', flexGrow: 1 }}> {/* Remove padding, allow content to grow */}
          {selectedPdf ? (
            <iframe
              src={pdfData}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title={selectedPdf?.fileName || 'PDF Document'}
            />
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Typography color="textSecondary">{t("text.NoPDFPreviewAvailable")}</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SplitPage;
